import React, { useCallback, useEffect, useState } from "react";
import ImgArt from "../../logistica/AreaOrdiniComponenti/OrdineComponenti/ImgArt";
import apiUrl from "../../Apiurl";
import axios from "axios";

function ImmaginiArticolo({
  prodIDps,
  size,
  refreshKey,
  onStatusChange,
  fonte = "VIG",
  zoomable = true,
  zoomSize = "original",
  imageClassName,
}) {
  const [IDimm, setIDimm] = useState(false);
  const [error, setError] = useState(null);
  const fontePrestashop = String(fonte).toUpperCase() === "BOT" ? "BOT" : "VIG";
  const notifyStatus = useCallback(
    (status) => {
      if (typeof onStatusChange === "function") {
        onStatusChange(Boolean(status));
      }
    },
    [onStatusChange]
  );

  useEffect(() => {
    const fetchID = async () => {
      if (!prodIDps) {
        setIDimm(false);
        setError(null);
        notifyStatus(false);
        return;
      }
      try {
        const res = await axios.get(
          apiUrl + "/prodotti/ps/getIDImmagineProdottoPS/" + fontePrestashop + "/" + prodIDps
        );
        setIDimm(res.data);
        setError(null);
        notifyStatus(Boolean(res.data));
      } catch (err) {
        console.error("Errore recupero immagine PS", err);
        setIDimm(false);
        setError("Impossibile recuperare l'immagine da Prestashop.");
        notifyStatus(false);
      }
    };

    fetchID();
  }, [prodIDps, refreshKey, notifyStatus, fontePrestashop]);

  return (
    <div className="tc">
      {error && <p className="dark-red">{error}</p>}
      {IDimm && (
        <ImgArt
          prodIDps={prodIDps}
          imgIDps={IDimm}
          size={size}
          fonte={fontePrestashop}
          allowBotImages={fontePrestashop === "BOT"}
          zoomable={zoomable}
          zoomSize={zoomSize}
          imageClassName={imageClassName}
          alt={`Immagine principale Prestashop ${fontePrestashop}`}
        />
      )}
    </div>
  );
}

export default ImmaginiArticolo;
